<template>
  <div class="scope-notice" role="note">
    <svg class="scope-notice-icon" viewBox="0 0 24 24" aria-hidden="true">
      <circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" stroke-width="2"/>
      <path d="M12 11v6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
      <circle cx="12" cy="7.5" r="1.3" fill="currentColor"/>
    </svg>
    <p><slot/></p>
  </div>
</template>

<script>
/**
 * Encart bleu d'information posé au-dessus d'un tableau dont les lignes sont filtrées (le texte se passe dans le slot).
 */
export default {
  name: 'TableScopeNotice'
}
</script>

<style lang="stylus" scoped>
@require '~/src/common/style/common.styl';
.scope-notice
  box-sizing border-box
  display flex
  align-items flex-start
  gap 12px
  width 100%
  margin 0 0 1rem
  padding 12px 16px
  border 1px #b9d3f5 solid
  border-left 4px #0069de solid
  border-radius 10px
  background-color #eaf2fd
  color FONT_COLOR
  p
    margin 0
    font-size 14px
    line-height 1.5
.scope-notice-icon
  flex none
  width 20px
  height 20px
  margin-top 1px
  color #0069de
</style>
